// Central coin wallet helpers.
// One source of truth in localStorage, shared by the Navbar, Homepage quiz,
// Category page and the in-game quiz. Components listen to the "coinsUpdated"
// event so the Navbar balance refreshes live whenever coins change.

const COINS_KEY = "coins";
const LEGACY_KEY = "quizScore"; // older builds stored the balance here

// Reward / penalty amounts
export const ENTRY_FEE = 100; // cost to enter a category contest
export const AD_REWARD = 100; // coins earned for watching a rewarded ad
export const CORRECT_REWARD = 100; // coins per correct answer
export const WRONG_PENALTY = 100; // coins lost per wrong answer

export function getCoins() {
  const raw = localStorage.getItem(COINS_KEY);
  if (raw !== null) return Number(raw) || 0;

  // migrate the legacy quizScore key if present
  const legacy = localStorage.getItem(LEGACY_KEY);
  return legacy !== null ? Number(legacy) || 0 : 0;
}

export function setCoins(value) {
  const v = Number(value) || 0;
  localStorage.setItem(COINS_KEY, v);
  localStorage.setItem(LEGACY_KEY, v); // keep legacy key in sync
  window.dispatchEvent(new CustomEvent("coinsUpdated", { detail: v }));
  return v;
}

export function addCoins(delta) {
  return setCoins(getCoins() + delta);
}
